import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * Pコード情報（PCode）の取得するサービス
 *
 * @export GetPcodeDataService
 * @class GetPcodeDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPcodeDataService extends PlessJsonResponderSub<any> {

  private pCode: string;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof GetPcodeDataService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPcodeDataService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPcodeDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPcodeDataService
   */
  execute(model: any, pCode: string, successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetPCodeData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPcodeDataService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
